import { defineMessages } from 'react-intl';

export default defineMessages({
  headerSignInLabel: {
    id: 'Sign in',
    defaultMessage: 'Sign in'
  },
  headerSignUpLabel: {
    id: 'Sign up',
    defaultMessage: 'Sign up'
  },
  profileNotificationsURL: {
    id: 'profileNotificationsURL',
    defaultMessage: '/profile/notifications'
  },
  headerNotificationsLabel: {
    id: 'Notifications',
    defaultMessage: 'Notifications'
  },
  headerDisconnectLabel: {
    id: 'Disconnect',
    defaultMessage: 'Disconnect'
  },
  headerWelcomeLabel: {
    id: 'Welcome',
    defaultMessage: 'Welcome',
  },
  headerDashboardLabel: {
    id: 'Dashboard',
    defaultMessage: 'Dashboard'
  },
  headerOfficeUrl: {
    id: 'headerOfficeUrl',
    defaultMessage: '/profile/notifications'
  },
  headerOfficeLabel: {
    id: 'Office',
    defaultMessage: 'Office'
  },
  headerReservationsLabel: {
    id: 'Reservations',
    defaultMessage: 'Reservations'
  },
  headerReservationsUrl: {
    id: 'headerReservationsUrl',
    defaultMessage: '/consultations/reservations'
  },
  headerAccountUrl: {
    id: 'headerAccountUrl',
    defaultMessage: '/account'
  },
  headerProfileLabel: {
    id: 'Profile',
    defaultMessage: 'Profile'
  },
  headerAccountLabel: {
    id: 'Configuration',
    defaultMessage: 'Configuration'
  },
  headerEnrollmentsUrl: {
    id: 'headerEnrollmentsUrl',
    defaultMessage: '/courses/enrollments'
  },
  enrollmentsLabel: {
    id: 'Your enrollments',
    defaultMessage: 'Your enrollments'
  },
  headerMessagesUrl: {
    id: 'headerMessagesUrl',
    defaultMessage: '/messages'
  },
  headerMessagesLabel: {
    id: 'Messages',
    defaultMessage: 'Messages'
  },
  headerWishlistLabel: {
    id: 'Wish list',
    defaultMessage: 'Wish list'
  },
  wishlistUrl: {
    id: 'wishlistUrl',
    defaultMessage: '/courses/wish-list'
  },
  headerBookmarksLabel: {
    id: 'Bookmarks',
    defaultMessage: 'Marcadores'
  },
  bookmarksUrl: {
    id: 'bookmarksUrl',
    defaultMessage: '/marcadores'
  },
});
